import { render, staticRenderFns } from "./file-category-form.vue?vue&type=template&id=18a24377"
import script from "./file-category-form.vue?vue&type=script&lang=js"
export * from "./file-category-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports